import Vue from 'vue'
import VueRouter from 'vue-router'
import multiguard from 'vue-router-multiguard'
//INCRIPTACION
import CryptoJS from "crypto-js";

import error_401 from "../views/errors/401";
import error_403 from "../views/errors/403";
import error_404 from "../views/errors/404";
import error_423 from "../views/errors/423";
import network_error from "../views/errors/network_error";
import error from "../views/errors/error";
// import ladingpage from "../views/ladingpage/landingpage.vue";
// import home from "../views/home/home.vue";
import register from "../views/register/register.vue";
import login from "../views/login/login.vue";
// import dasboard from "../views/dashboard/dashboard.vue"
import principal from "../views/principal/principal.vue"
import administrador from "../views/administrador/administrador/administrador.vue";
import reporte_usuarios from "../views/administrador/reporte_usuarios/administrador_reporte_usuarios.vue";
import bitacora from "../views/administrador/bitacora/bitacora.vue";
import empleado from "../views/empleado/empleado.vue"
import usuario_final from "../views/usuario_final/principal/usuario_final.vue"
import recuperar_pass from "../views/recuperar_contraseña/recuperar_contraseña/recuperar_contraseña.vue"
import confirmacion_recuperar_pass from "../views/recuperar_contraseña/confirmacion_recuperar_contraseña/confirmacion_recuperar_contraseña.vue"
import confirmar_correo from "../views/confirmar_correo/confirmar_correo.vue"
import perfil_usuario from "../views/usuario_final/perfil_usuario/perfil_usuario.vue"
import reporte_declaraciones from "../views/empleado_interno/reporte_declaraciones/reporte_declaraciones.vue";
import reporte_ingreso_facturas_retenciones from "../views/empleado_interno/reporte_ingreso/reporte_ingreso.vue"
import pago_declaracion from "../views/empleado_interno/pago_declaracion/pago_declaracion.vue";
import reporte_inicial from "../views/empleado_interno/reporte_inicial/reporte_inicial.vue";
import reporte_mensual_anual from "../views/empleado_interno/reporte_anual/reporte_anual.vue"
import reporte_mensual_anual_isr from "../views/empleado_interno/reporte_anual_isr/reporte_anual.vue"
import reporte_mensual_anual_usuario from "../views/usuario_final/reporte_mensual_anual/reporte_mensual_anual.vue"
import seguimiento_declaraciones from "../views/empleado_interno/seguimiento_declaraciones/seguimiento_declaracion.vue"
import seguimiento_pornit from "../views/empleado_interno/seguimiento_pornit/seguimiento_pornit.vue"
import reporte_masivo from "../views/administrador/reporte_masivo/administrador_reporte_masivo.vue"
import transaccion from "../views/administrador/transaccion/transaccion.vue"
import reporte_compras_ventas from '../views/empleado_interno/reporte_compras_ventas/reporte_compras_ventas.vue'
import mantenimiento_pc from '@/views/administrador/mantenimiento_pc/suscripcion_CRUD.vue';

import terminos_privacidad_servicio from '@/views/usuario_final/terminos_privacidad_servicio/terminos_privacidad_servicio.vue';

import declaraciones_colaborador from "@/views/administrador/declaraciones_colaborador/declaraciones_colaborador.vue"

import declaraciones_noconfirmadas_colaborador from '@/views/administrador/declaraciones_noconfirmadas_colaborador/declaraciones_noconfirmadas_colaborador.vue'

// declaraciones_colaborador.vue
import estado_declaracion from '@/views/usuario_final/estado_declaracion/estado_declaracion.vue'
import estado_declaracion_completo from '@/views/administrador/estado_declaracion_completo/estado_declaracion_completo.vue'
import estado_declaracion_admin from '@/views/administrador/estado_declaracion_completo/estado_declaracion_admin/estado_declaracion_admin.vue'

import reporte_usuarios_estado from "@/views/administrador/estado_usuarios/estado_usuarios.vue"

import reporte_maestro_mes from "../views/administrador/reporte_maestro/reporte_maestro.vue"

import mantenimientos from "../views/administrador/mantenimientos/mantenimientos.vue"
import mantenimiento_ros from "../views/administrador/mantenimiento_ros/mantenimiento_ros.vue"

import mantenimiento_gen from "../views/administrador/mantenimiento_gen/mantenimiento_gen.vue"

import seleccion_facturas_compras from "./../views/usuario_final/seleccion_facturas_compras/seleccion_facturas_compras.vue"

// vistas de notificacion
import notificacion_isr from "../views/usuario_final/notificacion_isr/notificacion_isr.vue"
import notificacion_iva from "../views/usuario_final/notificacion_iva/notificacion_iva.vue"


//vistas gestor
import gestor from "../views/gestor/landingpage/gestor_landingpage.vue"
import suscripcionExtraordinaria from "../views/gestor/suscripcion_extraordinaria/suscripcion_extraordinaria.vue"
import seguimiento_declaracion from "../views/gestor/seguimiento_declaracion/seguimiento_declaracion.vue"
import gestionUsuarios from "../views/gestor/gestion_usuarios/gestion_usuarios.vue";

// ServiciosExtras
import ServiciosExtras from "../views/usuario_final/servicios_extras/servicios_extras.vue";

Vue.use(VueRouter)

//proteger rutas admin_user
const isAdmin = (to, from, next) => {
  //Desincriptacion de datos del usuario (valor, clave)
  let informacion_incriptada = sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-todo');
  if (informacion_incriptada != null) {
    let key_pass = atob(sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-tic'))
    let bytes = CryptoJS.AES.decrypt(informacion_incriptada, key_pass + "byTeamT0d0T1c");
    //Casteo de información a estring
    let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
    //Casteo de JSON String a Object json
    let r = JSON.parse(informacion_desincriptada)
    let usuario = r.usuario[0]
    console.log("usuario", usuario);
    // let user = usuario;
    //claves para interacción con el sessión storage
    return r.rol.includes(1) ? next() : (sessionStorage.removeItem('dsgfv/&#$%sdksdn..sd5454sd-todo'), sessionStorage.removeItem('dsgfv/&#$%sdksdn..sd5454sd-tic'), next('/'));
  }
}

//proteger rutas admin_user
const isColaborador = (to, from, next) => {
  //Desincriptacion de datos del usuario (valor, clave)
  let informacion_incriptada = sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-todo');
  if (informacion_incriptada != null) {
    let key_pass = atob(sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-tic'))
    let bytes = CryptoJS.AES.decrypt(informacion_incriptada, key_pass + "byTeamT0d0T1c");
    //Casteo de información a estring
    let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
    //Casteo de JSON String a Object json
    let r = JSON.parse(informacion_desincriptada)
    let usuario = r.usuario[0]
    console.log("usuario", usuario);
    // let user = usuario;
    //claves para interacción con el sessión storage
    return r.rol.includes(1) || r.rol.includes(2) || r.rol.includes(4) ? next() : (sessionStorage.removeItem('dsgfv/&#$%sdksdn..sd5454sd-todo'), sessionStorage.removeItem('dsgfv/&#$%sdksdn..sd5454sd-tic'), next('/'));
  }
}

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: home
  // },
  {
    path: '/register',
    name: 'register',
    component: register
  },
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/recuperar_pass',
    name: 'recuperar_pass',
    component: recuperar_pass
  },
  {
    path: "/recuperacion_confirmacion/:encriptado",
    name: "confirmacion_recuperacion",
    component: confirmacion_recuperar_pass
  },
  {
    path: "/confirmacion_correo/:token/:id",
    name: 'confirmacion_correo',
    component: confirmar_correo
  },
  {
    path: '/notificacion_cliente_iva/:data_encriptada',
    name: 'notificacion_iva',
    component: notificacion_iva
  },
  {
    path: '/notificacion_cliente_isr/:data_encriptada',
    name: 'notificacion_isr',
    component: notificacion_isr
  },
  {
    path: '/dashboard',
    component: principal,
    children: [
      {
        path: "/reporte_declaracion",
        name: "reporte_declaracion",
        component: reporte_declaraciones,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/pago_declaracion",
        name: "pago_declaracion",
        component: pago_declaracion,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/administrador",
        name: "administrador",
        component: administrador,
        beforeEnter: multiguard([isAdmin])
      },
      {
        path: "/reporte_movimientos",
        name: "reporte",
        component: bitacora,
        beforeEnter: multiguard([isAdmin])
      },
      {
        path: "/mantenimientos",
        name: "mantenimientos",
        component: mantenimientos,
        beforeEnter: multiguard([isAdmin])
      },
      {
        path: "/usuario_final",
        name: "usuario_final",
        component: usuario_final
      },
      {
        path: "/empleado",
        name: "empleado",
        component: empleado,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/perfil_usuario/:tab",
        name: "perfil_usuario",
        component: perfil_usuario
      },
      {
        path: "/reporte_usuarios",
        name: "reporte_usuario",
        component: reporte_usuarios,
        beforeEnter: multiguard([isAdmin])
      },
      {
        path: "/reporte_inicial",
        name: "reporte_inicial",
        component: reporte_inicial,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/ingreso_facturas",
        name: "ingreso_facturas",
        component: reporte_ingreso_facturas_retenciones,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/reporte_anual",
        name: "reporte_anual",
        component: reporte_mensual_anual,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/massive_reporte",
        name: "massive_reporte",
        component: reporte_masivo,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/transaccion/listado",
        name: "transaccion",
        component: transaccion,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/reporte_anual/isr",
        name: "reporte_anual_isr",
        component: reporte_mensual_anual_isr,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/reporte_compras_ventas",
        name: "reporte_compras_ventas",
        component: reporte_compras_ventas,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/reporte_mensual_anual_usuario",
        name: "reporte_mensual_anual_usuario",
        component: reporte_mensual_anual_usuario,
      },
      {
        path: "/seguimiento_declaraciones",
        name: "seguimiento_declaraciones",
        component: seguimiento_declaraciones,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/seguimiento_pornit",
        name: "seguimiento_pornit",
        component: seguimiento_pornit,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/man_pc",
        name: "man_pc",
        component: mantenimiento_pc,
        beforeEnter: multiguard([isAdmin])
      },
      {
        path: "/man_gen",
        name: "man_gen",
        component: mantenimiento_gen,
        beforeEnter: multiguard([isAdmin])
      },
      {
        path: "/man_ros",
        name: "man_ros",
        component: mantenimiento_ros,
        beforeEnter: multiguard([isAdmin])
      },
      {
        path: "/terminos_privacidad_servicio",
        name: "terminos_privacidad_servicio",
        component: terminos_privacidad_servicio
      },

      {
        path: "/declaraciones_colaborador",
        name: "declaraciones_colaborador",
        component: declaraciones_colaborador,
        beforeEnter: multiguard([isAdmin])
      },

      {
        path: "/declaraciones_noconfirmadas_colaborador",
        name: "declaraciones_noconfirmadas_colaborador",
        component: declaraciones_noconfirmadas_colaborador,
        beforeEnter: multiguard([isAdmin]),
      },
      {
        path: "/estado_declaracion",
        name: "estado_declaracion",
        component: estado_declaracion
      },
      {
        path: "/seleccion_facturas_compras",
        name: "seleccion_facturas_compras",
        component: seleccion_facturas_compras
      },
      {
        path: "/estado_declaracion_completo",
        name: "estado_declaracion_completo",
        component: estado_declaracion_completo,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/estado_declaracion_admin/:usuario/:nombre/:completo/:cui/:nit/:password/:tipo_regimen",
        name: "estado_declaracion_admin",
        component: estado_declaracion_admin,
        beforeEnter: multiguard([isColaborador])
      },
      {
        path: "/reporte_usuarios_estado",
        name: "reporte_usuarios_estado",
        component: reporte_usuarios_estado,
        beforeEnter: multiguard([isAdmin])
      },
      {
        path: "/reporte_maestro_mes",
        name: "reporte_maestro_mes",
        component: reporte_maestro_mes,
        beforeEnter: multiguard([isAdmin])
      },
      {
        path: "/gestor",
        name: "gestor",
        component: gestor,
      },
      {
        path: "/gestor/seguimiento_declaracion",
        name: "seguimiento_declaracion",
        component: seguimiento_declaracion,
      }
      ,
      {
        path: "/suscripcion_extraordinaria",
        name: "suscripcionExtraordinaria",
        component: suscripcionExtraordinaria,
      },
      {
        path: "/gestor/gestion_usuarios",
        name: "gestion_usuarios",
        component: gestionUsuarios
      },
      {
        path: "/servicios_extras",
        name: "servicios_extras",
        component: ServiciosExtras
      },
      {
        path: "/reporte_transacciones_pasarela",
        name: "reporte_transacciones_pasarela",
        component: () => import("../views/administrador/reporte_transacciones_pasarela/reporte_transacciones_pasarela.vue"),
        beforeEnter: multiguard([isAdmin])
      },
      {
        path: "/reporte_usuarios_sin_forma_pago",
        name: "reporte_usuarios_sin_forma_pago",
        component: () => import("../views/administrador/reporte_usuarios_sin_forma_pago/reporte_usuarios_sin_forma_pago.vue"),
        beforeEnter: multiguard([isAdmin])
      }
      //demas vista aqui
    ]
  },
  {
    path: '/401',
    name: '401',
    component: error_401
  },
  {
    path: '/403',
    name: '403',
    component: error_403
  },
  {
    path: '/404',
    name: '404',
    component: error_404
  },
  {
    path: '/423',
    name: '423',
    component: error_423
  },
  {
    path: '/error',
    name: 'error',
    component: error
  },
  {
    path: '/network_error',
    name: 'network_error',
    component: network_error
  },
  {
    path: '*',
    redirect: "/error"
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
